// frontend/src/router/routes/adminRoutes.tsx
// UPDATED: Added provider areas route for admin access

import { Route } from "react-router-dom";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import UserManagement from "@/pages/UserManagement";
import CategoryManagement from "@/pages/CategoryManagement";
import CategoryDetails from "@/pages/CategoryDetails";
import ServiceTypeManagement from "@/pages/ServiceTypeManagement";
import ProviderManagement from "@/pages/ProviderManagement";
import ProviderAreasManagement from "@/pages/ProviderAreasManagement"; // ✅ ADD: Import areas component
import UserProfile from "@/pages/UserProfile"; // For admin user profile

export const adminRoutes = [
  <Route
    key="admin-users"
    path="/users"
    element={
      <ProtectedRoute
        requiredRoles={["admin", "super_admin"]}
        layout="admin"
      >
        <UserManagement />
      </ProtectedRoute>
    }
  />,
  
  <Route
    key="admin-categories"
    path="/categories"
    element={
      <ProtectedRoute
        requiredRoles={["admin", "super_admin"]}
        layout="admin"
      >
        <CategoryManagement />
      </ProtectedRoute>
    }
  />,
  
  <Route
    key="admin-category-details"
    path="/categories/:id"
    element={
      <ProtectedRoute
        requiredRoles={["admin", "super_admin"]}
        layout="admin"
      >
        <CategoryDetails />
      </ProtectedRoute>
    }
  />,
  
  <Route
    key="admin-service-types"
    path="/service-types"
    element={
      <ProtectedRoute
        requiredRoles={["admin", "super_admin"]}
        layout="admin"
      >
        <ServiceTypeManagement />
      </ProtectedRoute>
    }
  />,
  
  <Route
    key="admin-providers"
    path="/providers"
    element={
      <ProtectedRoute
        requiredRoles={["admin", "super_admin"]}
        layout="admin"
      >
        <ProviderManagement />
      </ProtectedRoute>
    }
  />,
  
  
 
  
  // User Profile route for admin
  <Route
    key="admin-user-profile"
    path="/profile"
    element={
      <ProtectedRoute 
        requiredRoles={["admin", "super_admin"]} 
        layout="admin"
      >
        <UserProfile />
      </ProtectedRoute>
    }
  />,
  
  // NOTE: All booking routes (/bookings, /bookings/pending, etc.)
  // have been moved to bookingRoutes.tsx to avoid route conflicts
];